import { ToastOptions } from 'react-toastify';

/** Тост о незаполненном регламенте: показывают все три места, откуда запускают синхронизацию.
 *
 * `autoClose: false` — оператору надо успеть уйти в настройки соревнования, а `pre-line`
 * оставляет перенос строки перед подсказкой про вкладку. */
export const MISSING_PERIODS_SETTINGS_TOAST: { message: string; options: ToastOptions } = {
  message:
    'Добавьте "Количество периодов в матче" и "Длительность матча". \nВ настройках турнира перейдите на вкладку "Условия", а затем в "Регламент".',
  options: {
    autoClose: false,
    bodyStyle: {
      whiteSpace: 'pre-line',
    },
  },
};
